module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [(this.service !== 'Direct Debit') ? _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/import/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.service === 'Direct Debit') ? _c('f7-fab', {
    staticClass: "leftfav bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/import/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.service === 'Payments') ? _c('f7-fab', {
    staticClass: "leftfav3 bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/createInvoice//"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.service === 'Direct Payments') ? _c('f7-fab', {
    staticClass: "leftfav3 bottomButton floatingButtonToolbarBlank",
    attrs: {
      "href": "/attachments/createRefund/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav2 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": function($event) {
        return _vm.extractCSV()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverAttachments",
      "subNavTitle": _vm.attachmentsPage_AttachmentsList,
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage showLargeScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "row rowSearchBar"
  }, [(this.service !== 'Direct Debit') ? _c('div', {
    staticClass: "firstButtonMarginLeft showLargeScreenOnly"
  }, [_c('a', {
    staticClass: "new-button-color",
    attrs: {
      "href": "/attachments/import/"
    }
  }, [_c('button', {
    staticClass: "new-button  milkyBlock boxRequest"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.import_item', {
    itemname: this.$i18n.t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))
  })))])], 1)])]) : _vm._e(), _vm._v(" "), (this.service === 'Direct Debit') ? _c('div', {
    staticClass: " firstButtonMarginLeft showLargeScreenOnly"
  }, [_c('a', {
    staticClass: "new-button-color",
    attrs: {
      "href": "/attachments/import/"
    }
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('attachments.import_attach')))])], 1)])]) : _vm._e(), _vm._v(" "), (this.service === 'Payments') ? _c('div', {
    staticClass: "showLargeScreenOnly"
  }, [_c('a', {
    staticClass: "new-button-color",
    attrs: {
      "href": "/attachments/createInvoice//"
    }
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('attachments.create_invoice')))])], 1)])]) : _vm._e(), _vm._v(" "), (this.service === 'Direct Payments') ? _c('div', {
    staticClass: "showLargeScreenOnly"
  }, [_c('a', {
    staticClass: "new-button-color",
    attrs: {
      "href": "/attachments/createRefund/"
    }
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('attachments.create_refund')))])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": function($event) {
        return _vm.extractCSV()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.extract_csv')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "search-list": "#attachment-list",
      "cancel-link": "Cancel",
      "placeholder": _vm.attachmentsPage_SearchAttachments,
      "clear-button": true,
      "virtual-init": true
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('cm-attachments-list', {
    attrs: {
      "service": _vm.service,
      "Attachments": _vm.Attachments
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b9284f3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b9284f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/attachments/CMAttachmentsPage.vue
// module id = 1667
// module chunks = 2